// extracted by mini-css-extract-plugin
export default {"spin":"Spinner_spin__u1Ns7"};